import React from "react";
import { formatarData } from "../../../../components/Formatters/DateTime";

const OcorrenciasFiscaisCard = ({ ocorrenciasFiscais }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Ocorrências Fiscais</b>
      </div>
      <div className="card-body">
        {" "}
        <center>
          <table className="table table-striped table-bordered" width="80%">
            <thead>
              <tr>
                <th>
                  <center>Descrição da Ocorrência</center>
                </th>
                <th>
                  <center>Data Inicial</center>
                </th>
                <th>
                  <center>Data Final</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {ocorrenciasFiscais?.map((ocorrencia) => (
                <tr>
                  <td>{ocorrencia.descricao}</td>
                  <td>
                    <center>{formatarData(ocorrencia.dataInicio, "dd/MM/yyyy")}</center>
                  </td>
                  <td>
                    <center>{formatarData(ocorrencia.dataFim, "dd/MM/yyyy")}</center>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default OcorrenciasFiscaisCard;
